import LoyaltyTierIcon from 'LuxKit/Icons/loyalty/LoyaltyTierIcon'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import { rem } from 'polished'
import styled, { keyframes } from 'styled-components'
import eases from 'styles/tools/eases'

const LeftAnimation = keyframes`
  from {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }

  to {
    opacity: 0.7;
    transform: translate(-110%, -50%) scale(0.8);
  }
`

const RightAnimation = keyframes`
  from {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }

  to {
    opacity: 0.7;
    transform: translate(10%, -50%) scale(0.8);
  }
`

const MiddleAnimation = keyframes`
  from {
    transform: translate(-50%, -50%) scale(1);
  }

  to {
    transform: translate(-50%, -50%) scale(1.2);
  }
`

const LogoContainer = styled.div`
  position: relative;

  &.small {
    height: ${rem(28)};
    width: ${rem(34)};
  }

  &.medium {
    height: ${rem(80)};
    width: ${rem(100)};
  }

  > * {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation-fill-mode: forwards;
    animation-duration: 0.5s;
    animation-timing-function: ${eases.iosBounce.out};
    animation-delay: 0.5s;
  }

  > :nth-child(1){
    animation-name: ${LeftAnimation};
  }

  > :nth-child(2){
    animation-name: ${RightAnimation};
  }

  > :nth-child(3){
    animation-name: ${MiddleAnimation};
  }
`

interface Props {
  size: 'small' | 'medium'
}

function TriplePointTakeoverLogo(props: Props) {
  const { size } = props

  const [tier] = useCurrentLoyaltyTier()
  return <LogoContainer className={size}>
    <LoyaltyTierIcon size={size === 'small' ? 22 : 40} tier={tier} />
    <LoyaltyTierIcon size={size === 'small' ? 22 : 40} tier={tier} />
    <LoyaltyTierIcon size={size === 'small' ? 22 : 40} tier={tier} />
  </LogoContainer>
}

export default TriplePointTakeoverLogo
